import React from 'react';

import { bandColorOptions } from './SectorsSettingsForm/constants';

import styles from './SectorsSettings.module.scss';

const ColorBadge = ({ colorId }: { colorId: number }) => {
	const colorCode = bandColorOptions.find((option) => option.name === colorId)?.color;

	return (
		<div
			className={styles.colorBadge}
			style={{ backgroundColor: colorCode }}
		/>
	);
};

export default ColorBadge;
